<!--
 * @Author: 苏航
 * @Date: 2021-05-25 08:35:14
 * @LastEditors: 苏航
 * @LastEditTime: 2021-09-15 13:30:21
 * @version: V.x
 * @Descripttion: 说明...
-->
<template>
  <div class="content">
    <div class="title">Privacy Policy </div>
    <div class="main html-view" v-html="html"></div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  data() {
    return {
      html: "",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$http.pages({ id: 1 }).then((res) => {
        if (res.code == 200) {
          this.html = res.data.content;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 3s;
}
.content {
  padding: 100px 0;
  .title {
    text-align: center;
    margin-bottom: 40px;
    font-size: 24px;
  }
  .main {
    width: 1000px;
    margin: 0 auto;
    .donghua {
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 220px;
        height: 220px;
      }
    }
  }
}
</style>